import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'

const withLoginToLastLocation = () => {
  return WrappedComponent => {
    return (props) => {
      const location = useLocation()
      const userId = useSelector(state => state.auth.user_id)

      useEffect(() => {
        const { pathname } = location
        if (
          !pathname.includes('/login') &&
          !pathname.includes('/callback') &&
          !pathname.includes('/redirect') &&
          !pathname.includes('/launch')
        ) {
          if(!localStorage.setItem('nextLoginPath', JSON.stringify({ user_id: userId, path: pathname }))) {
            // if we dont have local storage see if we can save to session storage
            sessionStorage.setItem('nextLoginPath', JSON.stringify({ user_id: userId, path: pathname }))
          }
        }
      }, [location.pathname])
      return (
        <WrappedComponent {...props}/>
      )
    }
  }
}

export default withLoginToLastLocation
